import React from "react";

export default () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      opacity="0.546851749"
    >
      <g
        id="lg-/-Grid-/-Items"
        transform="translate(-584.000000, -267.000000)"
        fill="#222629"
      >
        <g id="Icon/Plus" transform="translate(580.000000, 262.992188)">
          <path
            d="M12,4 C7.6,4 4,7.6 4,12 C4,16.4 7.6,20 12,20 C16.4,20 20,16.4 20,12 C20,7.6 16.4,4 12,4 Z M16,13 L13,13 L13,16 L11,16 L11,13 L8,13 L8,11 L11,11 L11,8 L13,8 L13,11 L16,11 L16,13 Z"
            id="Fill"
            opacity="0.8"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);
